export default "__VITE_ASSET__ea50f503__"